import Vue from 'vue';
import Router from 'vue-router';
import Editor from '../views/edit.vue';
import Mine from '../views/mine.vue';
import Put from '../views/put.vue';
import TaskCenter from '../views/taskCenter.vue';
import Folder from '../views/folder.vue';
import Preview from '../views/preview.vue';
import Print from '../views/print.vue';
import Login from '../views/login.vue';
import Home from '../views/home.vue';
import Help from '../views/help.vue';
import Template from '../views/template.vue';
import TemplateEdit from '../views/templateEdit.vue';
import Protocol from '../views/protocol.vue'
import Analysis from '../components/analysis.vue';
import SampleData from '../components/sampleData.vue';
import SingleAnalysis from '../components/singleAnalysis';
import CrossAnalysis from '../components/crossAnalysis';
import ArticleList from '../components/articleList.vue';
import ArticleEdit from '../components/articleEdit.vue';
import ArticleUpdate from '../components/articleUpdate.vue';
import Upgrade from '../views/upgrade';
import store from '@/store'

Vue.use(Router);
//push 
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}


const router = new Router({
  routes: [{
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol,
    },
    {
      path: '/preview',
      name: 'Preview',
      component: Preview,
    },
    {
      path: '/print',
      name: 'Print',
      component: Print,
    },
    // {
    //   path: '/',
    //   name: 'Home',
    //   redirect: '/home/mine',
    // },
    {
      path: '/',
      name: 'Upgrade',
      redirect: '/upgrade',
    },
    {
      path: '/upgrade',
      name: 'Upgrade',
      component: Upgrade,
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      redirect: '/home/mine',
      children: [{
          path: '/home/mine',
          name: 'Mine',
          component: Mine,
        },
        {
          path: '/home/put',
          name: 'Put',
          component: Put,
        },
        {
          path: '/home/edit',
          name: 'Editor',
          component: Editor,
          children: [{
              path: '/home/edit/analysis',
              name: 'Analysis',
              component: Analysis,
            },
            {
              path: '/home/edit/sampleData',
              name: 'SampleData',
              component: SampleData,
            },
            {
              path: '/home/edit/singleAnalysis',
              name: 'SingleAnalysis',
              component: SingleAnalysis,
            },
            {
              path: '/home/edit/crossAnalysis',
              name: 'CrossAnalysis',
              component: CrossAnalysis,
            }
          ]
        },
        {
          path: '/home/folder',
          name: 'folder',
          component: Folder,
        },
        {
          path: '/home/help',
          name: 'Help',
          component: Help,
          redirect: '/home/help/articleList',
          children: [{
              path: '/home/help/articleList',
              name: 'ArticleList',
              component: ArticleList
            },
            {
              path: '/home/help/articleEdit',
              name: 'ArticleEdit',
              component: ArticleEdit
            },
            {
              path: '/home/help/articleUpdate',
              name: 'ArticleUpdate',
              component: ArticleUpdate
            }
          ]
        },
        {
          path: '/home/taskCenter',
          name: 'TaskCenter',
          component: TaskCenter
        },
        {
          path: '/home/template',
          name: 'Template',
          component: Template,
        },
        {
          path: '/home/templateEdit',
          name: 'TemplateEdit',
          component: TemplateEdit,
        },
      ]
    }
  ],
});
router.beforeEach(async (to, from, next) => {
  if (to.name != 'Login' && !store.state.userInfo) {
    await store.dispatch("getUserInfo");
  }else if(to.name === 'Login' && !store.state.userInfo){
    next()
    return
  }
  if(to.name === 'Upgrade'){
    next()
  }else{
    next("/upgrade")
  }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js